'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'
import Image from 'next/image'
import styles from './HeaderSearchBox.module.css'
import { closeMobileMenu } from '@/utils/closeMobileMenu'

export default function HeaderSearchBox({
  headerStyle,
  placeholder = '搜尋商品',
  variant = 'desktop',
}) {
  const router = useRouter()

  const [keyword, setKeyword] = useState('')
  const [isFocus, setIsFocus] = useState(false)
  const [loading, setLoading] = useState(false)

  const [result, setResult] = useState({
    products: [],
    categories: [],
    brands: [],
  })

  const fontColor = headerStyle?.HeaderFontColor || '#000'

  useEffect(() => {
    const text = keyword.trim()

    if (!text) {
      setResult({
        products: [],
        categories: [],
        brands: [],
      })
      return
    }

    const timer = setTimeout(async () => {
      try {
        setLoading(true)

        const res = await fetch(
          `/api/search/get_GetShopSalePageByKeyword?keyword=${encodeURIComponent(text)}`
        )

        const data = await res.json()
        console.log(data.products)
        if (!res.ok) {
          setResult({
            products: [],
            categories: [],
            brands: [],
          })
          return
        }

        setResult({
          products: data?.products || [],
          categories: data?.categories || [],
          brands: data?.brands || [],
        })
      } catch (err) {
        console.error('搜尋失敗', err)

        setResult({
          products: [],
          categories: [],
          brands: [],
        })
      } finally {
        setLoading(false)
      }
    }, 300)

    return () => clearTimeout(timer)
  }, [keyword])

  const handleSearch = () => {
    const text = keyword.trim()
    if (!text) return

    router.push(`/product-list?keyword=${encodeURIComponent(text)}&page=1`, {
      scroll: true,
    })

    setIsFocus(false)

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'instant',
      })
    }, 0)

    if (variant === 'mobile') {
      closeMobileMenu()
    }
  }

  const handleProductClick = (product) => {
    router.push(product.TargetUrl || `/product-list/${product.ProductID}`)
    setIsFocus(false)
  }

  const handleCategoryClick = (category) => {
    router.push(`/shop?categoryId=${encodeURIComponent(category.CategoryID)}`)
    setIsFocus(false)
  }

  const handleBrandClick = (brand) => {
    router.push(`/shop?brandId=${encodeURIComponent(brand.BrandID)}`)
    setIsFocus(false)
  }

  const hasResult =
    result.products.length > 0 ||
    result.categories.length > 0 ||
    result.brands.length > 0

  const showDropdown = isFocus && keyword.trim()

  return (
    <div
      className={`${styles.searchWrap} ${
        variant === 'mobile' ? styles.mobile : styles.desktop
      } me-3`}
    >
      <form
        className={styles.searchBox}
        onSubmit={(e) => {
          e.preventDefault()
          handleSearch()
        }}
      >
        <input
          type="text"
          value={keyword}
          placeholder={placeholder}
          onFocus={() => setIsFocus(true)}
          onChange={(e) => setKeyword(e.target.value)}
          className={styles.input}
        />

        {/* {keyword && (
          <button
            type="button"
            className={styles.clearBtn}
            onClick={() => {
              setKeyword('')
              setResult({
                products: [],
                categories: [],
                brands: [],
              })
            }}
          >
            ×
          </button>
        )} */}

        <button
          type="submit"
          className={styles.searchBtn}
          aria-label="搜尋"
          style={{ color: fontColor }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="#icon_search" />
          </svg>
        </button>
      </form>
    </div>
  )
}
